import React, { Component, PropTypes } from 'react';
import './Electrode.scss';

class Electrode extends Component {
  render() {
    return (
      <div className="pokemon">
        <div className="electrode">
          <div className="head">

          </div>
          <div className="body">

          </div>
        </div>
      </div>
    );
  }
}

export default Electrode;



/** WEBPACK FOOTER **
 ** ./source/101-electrode/Electrode.js
 **/